"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.players = void 0;
// eslint-disable-next-line import/no-cycle
const flv_http_1 = require("../internal/player/flv-http");
const hlsjs_1 = require("../internal/player/hlsjs");
const mp4_ws_1 = require("../internal/player/mp4-ws");
const native_hls_1 = require("../internal/player/native-hls");
const webrtc_1 = require("../internal/player/webrtc");
exports.players = {
    "native-hls": native_hls_1.NativeHlsPlayer,
    hlsjs: hlsjs_1.HlsJsPlayer,
    webrtc: webrtc_1.WebrtcPlayer,
    mp4ws: mp4_ws_1.Mp4WsPlayer,
    flvhttp: flv_http_1.FlvHttpPlayer,
};
//# sourceMappingURL=player.js.map